import {BasicClient} from '@/utils/httpClient';

export default class OnBoarding {
  client: BasicClient;
  constructor(){
    this.client = new BasicClient();
  }
  getBaseConfig():any{
    return this.client.exec('/OnBoarding/CountryTemplate', 'GET');
  }
  save(name,config,msj,id_tipo_msj,url,id_categoria_tipo_empresa):any{
    var params = {"nombre" : name, "template" : config}
    if(msj!=''&& msj!=undefined && msj!=null){Object.assign(params,{"mensaje_bienvenida":msj})}

    if(url!=''&& url!=undefined && url!=null){Object.assign(params,{"url":url})}

    if(id_tipo_msj!=''&& id_tipo_msj!=undefined && id_tipo_msj!=null){Object.assign(params,{"id_tipo_msg_bienvenida" : parseInt(id_tipo_msj)})}

    if(id_categoria_tipo_empresa!=''&& id_categoria_tipo_empresa!=undefined && id_categoria_tipo_empresa!=null){Object.assign(params,{"id_categoria_tipo_empresa" : parseInt(id_categoria_tipo_empresa)})}

    return this.client.exec('/OnBoarding/CompanyTemplate', 'POST', params);
  }
  getConfigById(id):any{
    return this.client.exec('/OnBoarding/CompanyTemplate/'+id, 'GET',  {"deleted" : 0});
  }
  editTemplate(id,name,config,msj,id_tipo_msj,url):any{
    var params = {"nombre" : name, "template" : config}
    if(msj!=''&& msj!=undefined && msj!=null){Object.assign(params,{"mensaje_bienvenida":msj})}

    if(url!=''&& url!=undefined && msj!=null){Object.assign(params,{"url":url})}

    if(id_tipo_msj!=''&& id_tipo_msj!=undefined && id_tipo_msj!=null){Object.assign(params,{"id_tipo_msg_bienvenida" : parseInt(id_tipo_msj)})}

    return this.client.exec('/OnBoarding/CompanyTemplate/'+id, 'PUT', params  );
  }
  getListTemplate():any{
    return this.client.exec('/OnBoarding/CompanyTemplate', 'GET');
  }
  disabledTemplate(id,value):any {
    return this.client.exec('/OnBoarding/CompanyTemplate/'+id, 'PATCH',{"activo" : value});
  }
  getStatistics(id){
    return this.client.exec('OnBoarding/UserOnBoarding/'+id+'/statistics' ,'GET');
  }
  getWelcome(){
    return this.client.exec('/OnBoarding/WelcomeMessages/' ,'GET',{"idioma" : 'AR'});
  }
  postWelcomeImage(template_id,file){
    return this.client.exec('/OnBoarding/'+template_id+'/WelcomeImage', 'POST', {"template_id" : template_id, "file" : file}, true);
  }
  deleteWelcomeImage(template_id){
    return this.client.exec('/OnBoarding/'+template_id+'/WelcomeImage', 'DELETE');
  }
  sendNotification(ids) {
    return this.client.exec('/OnBoarding/NotifyPendingDocuments', 'POST', { user: ids })
  }
  onBoardingReactivate(idUser: number, idCompanyTemplate: string, genEforms: number) {
    let params = {
      iduser: idUser,
      idCompanyTemplate: idCompanyTemplate,
      genEforms: genEforms
    };
    return this.client.exec(`/OnBoarding/UserOnBoarding`, 'POST', params)
  }
}